
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";

class OrderHelper {

    static getStatusName(statusId) {
        const status = AppContext.getOrderStatusById(statusId)
        if (!status) {
            return ''
        }
        return status.attributes.name
    }

}

export default injectIntl(OrderHelper)


// WEBPACK FOOTER //
// ./src/order/orderhelper.jsx